import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface InjuryPageProps extends BasePageProps {}

type InjuryState = {
    tipo_sport: any

    problemi_precedenti: boolean | undefined
    sport: string | undefined
    partichiSport: boolean | undefined

    problemi_precedentiError: string | undefined
    sportError: string | undefined
    partichiSportError: string | undefined
}

export type InjuryPageState = InjuryState & BasePageState

export const injuryPageInitialState : InjuryPageState = {
    ...basePageInitialState,
    ...{
        tipo_sport: undefined,

        problemi_precedenti: undefined,
        sport: undefined,
        partichiSport: undefined,

        problemi_precedentiError: undefined,
        sportError: undefined,
        partichiSportError: undefined,
    }
}

export const injuryUpdate = createAction<InjuryPageState>('injury/update')

export const injuryReducer = createReducer ( 
    injuryPageInitialState,
    (builder) => {
        builder.addCase(injuryUpdate, (state, action) => {
            return action.payload as InjuryPageState
        })
    }
)

export type InjuryRootState = ReturnType<typeof store.getState>
export type InjuryDispatch = typeof store.dispatch